<script setup lang="ts">
import { watch } from 'vue'
import store from '../../store'

watch(
  () => store.featuresToAnimate.size,
  () => {
    updateNoMotionSpaces()
  },
)

const updateNoMotionSpaces = () => {
  const floorplan = store.activeFloorplan
  if (!floorplan || !store.incident?.ongoing) {
    store.setNoMotionSpaces([])
    return
  }

  const noMotionSpaces = floorplan.spaces.filter((space) => {
    const hasMotion = space.groups.some((g) => store.featuresToAnimate.has(g.pid))
    return !hasMotion
  })
  store.setNoMotionSpaces(noMotionSpaces)
}
</script>

<template>
  <section class="motion-event-list">
    <h2>No motion Detected</h2>
    <ul>
      <li v-for="space in store.noMotionSpaces" :key="space.pid">
        <i class="pi pi-box" style="margin-right: 4px" />
        <p>{{ space.name }}</p>
      </li>
    </ul>
    <p v-if="!store.noMotionSpaces.length" class="no-info">No info to display</p>
  </section>
</template>

<style scoped>
.motion-event-list {
  padding-bottom: 16px;
}
.motion-event-list li {
  list-style-type: none;
  display: flex;
  align-items: baseline;
}
.motion-event-list ul {
  padding: 0;
  padding-top: 8px;
  margin: 0;
}
.motion-event-list h2 {
  color: var(--grayscale-800, #49494a);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.no-info {
  color: var(--global-textSecondaryColor, #6b7280);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
}
</style>
